// extracted by mini-css-extract-plugin
export default {"sectionTitle":"Appearance_sectionTitle__8sq0F","container":"Appearance_container__eZ1b+"};